import { __decorate } from "tslib";
import { proxy, subscribe } from '@/infrastructure/object-reactive/object-reactive';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { DEFAULT_USER_SETTING } from '../constants';
let UserSettingModelImpl = class UserSettingModelImpl {
    constructor() {
        this._userSetting = proxy(null);
    }
    get userSetting() {
        return this._userSetting.value;
    }
    updateUserSetting(userSetting) {
        this._userSetting.value = {
            ...DEFAULT_USER_SETTING,
            ...userSetting,
        };
    }
    updateRowHeightStyle(rowHightType) {
        this._userSetting.value.row_height = rowHightType;
    }
    updateGoToWhere(goToWhere) {
        this._userSetting.value.go_to_where = goToWhere;
    }
    subscribeUserSetting(callback) {
        const dispose = subscribe(() => this._userSetting.value, (newVal) => {
            callback(newVal);
        });
        return dispose;
    }
};
UserSettingModelImpl = __decorate([
    injectable()
], UserSettingModelImpl);
export { UserSettingModelImpl };
